(function () {
  'use strict';

  function initSocialProof(section) {
    if (!section || section.dataset.sspReady === 'true') return;
    section.dataset.sspReady = 'true';

    var track = section.querySelector('[data-ssp-track]');
    var prev = section.querySelector('[data-ssp-prev]');
    var next = section.querySelector('[data-ssp-next]');

    if (!track) return;

    function scrollAmount() {
      var card = track.querySelector('.snapshop-social-proof__card');
      if (!card) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    async function addVariant(variantId) {
      var id = Number(variantId);
      if (!id || Number.isNaN(id)) throw new Error('Invalid product option.');

      if (window.SnapShopCart && typeof window.SnapShopCart.add === 'function') {
        return window.SnapShopCart.add(id, 1, {});
      }

      var response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: id, quantity: 1 })
      });

      var data = await response.json().catch(function () { return null; });
      if (!response.ok) {
        var message = data && (data.description || data.message);
        throw new Error(message || 'Unable to add this item.');
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));

      if (window.SnapShopCart && typeof window.SnapShopCart.refresh === 'function') {
        await window.SnapShopCart.refresh();
      }
      if (window.SnapShopCart && typeof window.SnapShopCart.open === 'function') {
        window.SnapShopCart.open();
      }

      return data;
    }

    section.querySelectorAll('[data-ssp-add]').forEach(function (button) {
      button.addEventListener('click', async function () {
        if (button.disabled || button.classList.contains('is-loading')) return;

        var text = button.querySelector('[data-ssp-add-text]');
        var status = button.parentElement ? button.parentElement.querySelector('[data-ssp-add-status]') : null;
        var defaultText = button.dataset.defaultText || 'ADD TO CART';
        var originalText = text ? text.textContent : defaultText;

        button.classList.remove('is-added', 'is-error');
        button.classList.add('is-loading');
        button.disabled = true;
        if (text) text.textContent = 'ADDING...';
        if (status) status.textContent = '';

        try {
          await addVariant(button.dataset.variantId);
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          if (text) text.textContent = 'ADDED TO CART';
          if (status) status.textContent = 'Added to your cart.';

          window.setTimeout(function () {
            button.classList.remove('is-added');
            button.disabled = false;
            if (text) text.textContent = originalText;
            if (status) status.textContent = '';
          }, 1800);
        } catch (error) {
          button.classList.remove('is-loading');
          button.classList.add('is-error');
          button.disabled = false;
          if (text) text.textContent = 'TRY AGAIN';
          if (status) status.textContent = error && error.message ? error.message : 'Unable to add this item.';

          window.setTimeout(function () {
            button.classList.remove('is-error');
            if (text) text.textContent = originalText;
          }, 2200);
        }
      });
    });
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-snapshop-social-proof]')) {
      initSocialProof(scope);
    }
    scope.querySelectorAll('[data-snapshop-social-proof]').forEach(initSocialProof);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
